/**
  * 新品建档接口
  */

//  import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const newproduct = {
    //------------------------- 新品建档 （超市）--------------------------------------
    // 商品大类接口
    getGoodsClass (params) {
      return axios.post('/commoditymanagement/itemDept/itemDeptList',qs.stringify(params));
    },
    // 商品中类下拉列表接口
    getItemClasssList (params) {
      return axios.post('/commoditymanagement/itemClass/getItemClasssList',qs.stringify(params));
    },
    // 商品小类下拉列表接口
    getItemSclsList (params) {
      return axios.post('/commoditymanagement/itemScls/itemSclsList',qs.stringify(params));
    },
    // 商品细类下拉列表接口
    getItemSsubClsList (params) {
      return axios.post('/commoditymanagement/itemSsubCls/itemSsubClsList',qs.stringify(params));
    },
    //------------------------- 新品申请--------------------------------------
    //获取新增单号接口
    geItemAppCode (params) {
      return axios.post('/idgenerator/generator/getId',params);
    },

    //新增商品档案操作申请
    insertItemmasterApplication (params) {
      return axios.post('/commodityarchives/itemmasterApplication/insertItemmasterApplication',params);
    },
    
    //修改商品档案操作申请(主要针对省区change)
    updateItemmasterApplication (params) {
      return axios.post('/commodityarchives/itemmasterApplication/updateItemmasterApplication',params);
    },
    
    
    //根据档案id查询档案详情以及商品详情list
    getselectItemmaAppDetailByByAtt (params) {
      return axios.post('/commodityarchives/itemmasterApplication/getselectItemmaAppDetailByByAtt',qs.stringify(params));
    },

    //审核商品主档基本信息
    reviewAppItemmasterBaseinfo (params) {
      return axios.post('/commodityarchives/appItemmasterBaseinfo/reviewAppItemmasterBaseinfo',qs.stringify(params));
    },

    
    //------------------------- 新品明细--------------------------------------
    //新品建档全部数据保存
    saveAppitemAllData (params) {
      return axios.post('/commodityarchives/appItemmasterBaseinfo/saveAppitemAllData',params);
    },

    //新建-保存商品主档基本属性（基本信息&基础属性&备注）
    insertAppItemmasterBaseinfo (params) {
      return axios.post('/commodityarchives/appItemmasterBaseinfo/insertAppItemmasterBaseinfo',params);
    },

    //修改-商品主档基本属性（基本信息&基础属性&备注）
    updateAppItemmasterBaseinfo (params) {
      return axios.post('/commodityarchives/appItemmasterBaseinfo/updateAppItemmasterBaseinfo',params);
    },

    //新增商品UDA属性
    insertAppItemUda (params) {
      return axios.post('/commodityarchives/appItemUda/insertAppItemUda',params);
    },

    //修改商品UDA属性
    updateAppItemUda (params) {
      return axios.post('/commodityarchives/appItemUda/updateAppItemUda',qs.stringify(params));
    },

    //新增商品供应商信息
    insertAppItemmasterSupp (params) {
      return axios.post('/commodityarchives/appItemmasterSupp/insertAppItemmasterSupp',params);
    },

    //修改商品供应商信息
    updateAppItemmasterSupp (params) {
      return axios.post('/commodityarchives/appItemmasterSupp/updateAppItemmasterSupp',qs.stringify(params));
    },
    
    //新增商品附件
    insertAppItemmasterAppendix (params) {
      return axios.post('/commodityarchives/appItemmasterAppendix/insertAppItemmasterAppendix',qs.stringify(params));
    },

    //新增商品附件-批量
    insertAppItemmasterAppendixList (params) {
      return axios.post('/commodityarchives/appItemmasterAppendix/insertAppItemmasterAppendixList',params);
    },
    
    //修改商品附件
    updateAppItemmasterAppendix (params) {
      return axios.post('/commodityarchives/appItemmasterAppendix/updateAppItemmasterAppendix',qs.stringify(params));
    },

    //删除商品附件
    deleteAppItemmasterAppendix (params) {
      return axios.post('/commodityarchives/appItemmasterAppendix/deleteAppItemmasterAppendix',qs.stringify(params));
    },

    //根据商品id查询附件
    selectAppItemmasterAppendixByByAttributes (params) {
      return axios.post('/commodityarchives/appItemmasterAppendix/selectAppItemmasterAppendixByByAttributes',qs.stringify(params));
    },

    //根据商品id查询商品UDA属性
    selectAppItemUdaByByAttributes (params) {
      return axios.post('/commodityarchives/appItemUda/selectAppItemUdaByByAttributes',qs.stringify(params));
    },
    
    // 根据商品id查询商品基本属性（基本信息&基础属性&备注）
    selectAppItemmasterBaseinfoById (params) {
      return axios.post('/commodityarchives/appItemmasterBaseinfo/selectAppItemmasterBaseinfoById',qs.stringify(params));
    },

    //根据商品id查询商品供应商信息
    selectAppItemmasterSuppByByAttributes (params) {
      return axios.post('/commodityarchives/appItemmasterSupp/selectAppItemmasterSuppByByAttributes',qs.stringify(params));
    },
    
    //模糊搜索二级供应商
    selectSubSupplier(params){
      return axios.post('/scm-supp/supplier/selectSuppBySuppNameOrSuppCodeNoPage',qs.stringify(params));
    },
    
    //模糊搜索品牌
    selectBrandByCodeOrName(params){
      return axios.post('/rmsinteractservice/cmxStoreIp/selectBrandByCodeOrName',qs.stringify(params));
    },
    
    //根据品牌code查品牌name
    selectBrandByCode(params){
      return axios.post('/rmsinteractservice/cmxStoreIp/selectBrandByCode',qs.stringify(params));
    },

    //新品批量导入
    uploadItemMasterExpor: () => { return '/commodityarchives/itemMasterImport/uploadItemMasterExpor'},


    //附件上传
    uploadFiles(url,params) {
      return axios({
          method: 'post',
          url: url,
          data: params,
          timeout: 1000 * 60 * 120,
          headers: { 'Content-Type': 'multipart/form-data'},
      });
    },
    uploadFilesFun: () => { return '/contentmanagement/uploadFiles'},

    //------------------------- 新品申请单--------------------------------------
    //新品申请单查询
    selectPageItemmasterApplicationByByAttributes(params){
      return axios.post('/commodityarchives/itemmasterApplication/selectPageItemmasterApplicationByByAttributes', qs.stringify(params));
    },
    //提交或者作废商品档案
    submitItemmasterApplication(params){
      return axios.post('/commodityarchives/itemmasterApplication/submitItemmasterApplication', qs.stringify(params));
    },
    //导出新品申请单
    exportItemmasterApplicationByAttributes(params){
      return axios({
        method: 'post',
        url: '/commodityarchives/itemmasterApplication/exportItemmasterApplicationByAttributes',
        data: qs.stringify(params),
        timeout: 1000 * 60 * 2,
        responseType: 'blob'
      });
    },

    //新品建档 1124 优化需求
    //导出新品申请
    exportItemInfo(params){
      return axios({
        method: 'post',
        url: '/commodityarchives/appItemmasterBaseinfo/exportItemInfo',
        data: qs.stringify(params),
        timeout: 1000 * 60 * 2,
        responseType: 'blob'
      });
    },
    
    //模糊搜索 用户
    selectParticipantsDto(params){
      return axios.post('/authorization/participants/selectParticipantsDtoByCodeOrName',qs.stringify(params));
    },

    //根据uda信息查询uda下拉框
    getUdaValuesByUda(params){
      return axios.post('/commoditymanagement/uda/getUdaValuesByUda',qs.stringify(params));
    },

    //根据大类查询该大类必填UDA
    selectRequiredUdaByDept(params){
      return axios.post('/commoditymanagement/udaItemDefaults/selectRequiredUdaByDept',qs.stringify(params));
    },

    
    //商品标签 需求
    //属性标签列印
    exportLabelsColumnByItemappId(params){
      return axios({
        method: 'get',
        url: '/commodityarchives/appItemmasterLabels/exportLabelsColumnByItemappId',
        timeout: 1000 * 60 * 2,
        params:params,
        responseType: 'blob',
        headers: { 'Content-Type': 'application/octet-stream' }
      });
    },

    //属性标签 查看
    selectItemLabelsByItemappIdAndAppitemid(params){
      return axios.post('/commodityarchives/appItemmasterLabels/selectItemLabelsByItemappIdAndAppitemid',qs.stringify(params));
    },

    //属性标签 修改
    updateAppItemmasterLabelsList(params){
      return axios.post('/commodityarchives/appItemmasterLabels/updateAppItemmasterLabelsList',params);
    },
    
    //查询类别关联的标签值
    selectLValueByCtg(params){
      return axios.get('/labelsmanager/labelsDefine/selectLValueByCtg',{params:params});
    },
    
    
    //------------------------- 新品建档 （供应商）--------------------------------------
    //建档取消单品查询
    selectCancelReportBySupp(params){
      return axios.post('/commodityarchives/appItemmasterBaseinfo/selectCancelReportBySupp',qs.stringify(params));
    },

    //根据供应商编码查询供应商可申请商品数目
    selectSuppliersCanApplyNum(params){
      return axios.post('/commodityarchives/appItemmasterBaseinfo/selectSuppliersCanApplyNum',qs.stringify(params));
    },
    
    //供应商创建新的申请单
    createNewItemmasterApplication(params){
      return axios.post('/commodityarchives/appItemmasterBaseinfo/createNewItemmasterApplication',params);
    },
    
    // 获取供应商默认值
    getDefaultValue(params){
      return axios.post('/scm-supp/supplier/selectComposite',params);
    },
};

export default newproduct;


// WEBPACK FOOTER //
// ./src/api/api_newproduct.js